import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TextField } from 'fields';
import { useField } from 'formik';
import {
  calculateCropPacksFromQuantity,
  calculateCropQuantityFromPacks,
  getCropPackSize,
} from 'utils';

export default function Quantity() {
  const { t } = useTranslation('CreateCropOrder', { keyPrefix: 'ProductForm' });

  const [{ value: productData = {} }] = useField('productData');
  const [{ value: packagedItemReference = '' }] = useField('packagedItemReference');
  const [{ value: packagedItemQty }, , { setValue: setPackagedItemQty }] =
    useField('packagedItemQty');
  const [, , { setValue: setQuantity }] = useField('quantity');
  const disabled = !packagedItemReference;

  const packSize = useMemo(() => getCropPackSize({ productData }), [productData]);

  const handleQuantityChange = useCallback(
    async (value) => {
      const packs = calculateCropPacksFromQuantity(Number(value), { productData });

      if (!packs) {
        await setPackagedItemQty('');
        return;
      }

      await setPackagedItemQty(packs);
    },
    [productData, setPackagedItemQty],
  );

  const handleQuantityBlur = useCallback(async () => {
    if (!packSize || !packagedItemQty) return;

    const roundedQuantity = calculateCropQuantityFromPacks(packagedItemQty, { productData });

    if (roundedQuantity) {
      await setQuantity(roundedQuantity);
    }
  }, [packSize, packagedItemQty, productData, setQuantity]);

  return (
    <TextField
      name="quantity"
      label={t('labels.quantity')}
      placeholder={t('placeholders.quantity')}
      required
      disabled={disabled}
      onBlur={handleQuantityBlur}
      handleChangeCb={handleQuantityChange}
    />
  );
}
